import styled from 'styled-components';

import { colors, breakpoints } from 'definitions';

import CameraIcon from 'icons/CameraIcon'

export const Camera = styled(CameraIcon)`
 	cursor: pointer;
    vertical-align: middle;
    width: 34%;
    height: 34%;
    padding: 10px;
    fill: ${colors.icons.white};
    content: '';
    background-color: #b9c6d8;
    border-radius: 30%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

/* 300px de diámetro más 64px de margen empujaban todos los campos contra el
   borde derecho de la tarjeta. A 140px el logo sigue siendo reconocible y el
   formulario recupera el ancho. */
export const Circle = styled.div`
	width: 140px;
	height: 140px;
	position: relative;
	border-radius: 50%;
	background: ${colors.background.veryLightGray};
	border: 2px dashed #c6d2e2;
	outline: none;
	cursor: pointer;
	transition: opacity .24s ease-in-out;

	:hover {
		opacity: 0.7;
	}

	${breakpoints.tablet} {
		width: 120px;
		height: 120px;
	}
`;

export const Picture = styled.img`
	width: 140px;
	height: 140px;
	position: relative;
	border-radius: 50%;
	outline: none;
	transition: opacity .24s ease-in-out;
    cursor: pointer;
	object-fit: cover;
	:hover {
		opacity: 0.7;
	}

	${breakpoints.tablet} {
		width: 120px;
		height: 120px;
	}
`;
